import { useEffect } from "react";

const ThirdPartyScripts = () => {
  useEffect(() => {
    // ZENDESK SCRIPT
    const zenDeskScript = document.createElement("script");
    zenDeskScript.id = "ze-snippet";
    zenDeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=349e0216-916e-4eec-a3ca-5aee26360462";
    zenDeskScript.async = true;
    document.body.appendChild(zenDeskScript);

    // KLAVIYO SCRIPT
    const klaviyoScript = document.createElement("script");
    klaviyoScript.async = true;
    klaviyoScript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=TjmeUF";
    document.body.appendChild(klaviyoScript);

    return () => {
      // Cleanup scripts when unmounting (optional)
      document.getElementById("ze-snippet")?.remove();
      document.querySelector('script[src*="klaviyo"]')?.remove();
    };
  }, []);

  return null; // Nothing gets rendered
};

export default ThirdPartyScripts;
